export default "__VITE_ASSET__BfnMCZo3__"